import { Box } from '@mantine/core'

interface VerticalBarProps {
	value: number // height in percentage or px
	color?: string
	width?: number
	maxHeight?: number
}

export function VerticalBar({
	value,
	color = '#4CAF50',
	width = 55,
}: VerticalBarProps) {
	return (
		<Box
			style={{
				width,
				height: `${value}px`,
				backgroundColor: color,
				borderRadius: 6,
				transition: 'height 0.3s ease',
			}}
		/>
	)
}
